export enum ENUM_OPERATOR {
  EQUAL = 'eq',
  NOT_EQUAL = 'neq',
  GREATER_THAN = 'gt',
  // GREATER_THAN_OR_EQUAL = 'gte',
  LESS_THAN = 'lt',
  // LESS_THAN_OR_EQUAL = 'lte',
  CONTAINS = 'contains',
  // NOT_CONTAINS = 'not_contains',
  // STARTS_WITH = 'startsWith',
  // ENDS_WITH = 'endsWith',
  // IN = 'in',
  // NOT_IN = 'not_in',
}

export interface IPayloadSaveData {
  schemaName: string
  data: any
}

export interface IPayloadQueryData {
  schemaName: string
  filters?: {
    fieldName: string
    operator: ENUM_OPERATOR
    value: any
  }[]
  sortBy?: string
  sortDirection?: string
  pageNumber?: number
  pageSize?: number
}
